// Тоггл «Новая главная» + ссылка «Что изменилось» (business_apps#1486 §4).
// Стоит справа от заголовка «Мои устройства» в обоих вариантах.

import React, { useEffect } from 'react'
import styled, { useTheme } from 'styled-components'
import { useDispatch, useSelector } from 'react-redux'
import { Link as RouterLink } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { FormControlLabel, Typography, useMediaQuery } from '@material-ui/core'
import { BlueSwitch } from 'shared/ui/BlueSwitch/BlueSwitch'
import { trackHomeVariantSwitch } from 'utils/navMetrics'
import { HOME_VARIANTS, WHATS_NEW_PATH } from '../model/constants'
import { updateUserSettings } from '../model/services'
import { selectVariantUpdating, selectFleetSize } from '../model/selectors'
import { markToggleSeen, daysSinceToggleFirstSeen } from '../model/storage'
import { TextLink } from './HomeCard'

const Row = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
`

export default function HomeVariantSwitch({ variant }) {
  const { t } = useTranslation(['devices'])
  const dispatch = useDispatch()
  const theme = useTheme()
  const isMobile = useMediaQuery(`(max-width:${theme.sizes.tablet})`)
  const updating = useSelector(selectVariantUpdating)
  const fleetSize = useSelector(selectFleetSize)

  useEffect(() => {
    markToggleSeen()
  }, [])

  const handleChange = (event) => {
    const to = event.target.checked ? HOME_VARIANTS.V2 : HOME_VARIANTS.V1
    trackHomeVariantSwitch({
      from: variant,
      to,
      daysSinceFirstSeen: daysSinceToggleFirstSeen(),
      fleetSize: fleetSize ?? undefined,
    })
    dispatch(updateUserSettings({ home_variant: to }))
  }

  return (
    <Row>
      <FormControlLabel
        style={{ margin: 0 }}
        control={
          <BlueSwitch
            checked={variant === HOME_VARIANTS.V2}
            onChange={handleChange}
            disabled={updating}
          />
        }
        label={
          <Typography variant="body2" color="textSecondary">
            {isMobile
              ? t('devices:home_v2.toggle_short')
              : t('devices:home_v2.toggle')}
          </Typography>
        }
      />
      {!isMobile && (
        <TextLink component={RouterLink} to={WHATS_NEW_PATH} variant="body2">
          {t('devices:home_v2.whats_changed')}
        </TextLink>
      )}
    </Row>
  )
}
